__turbopack_context__.v({
  "chart-controls": "QV9Uea_chart-controls",
  "chart-data": "QV9Uea_chart-data",
  "config-fields": "QV9Uea_config-fields",
  "configuration": "QV9Uea_configuration",
  "content-layout": "QV9Uea_content-layout",
  "coverage-grid": "QV9Uea_coverage-grid",
  "document-header": "QV9Uea_document-header",
  "document-pane": "QV9Uea_document-pane",
  "document-section": "QV9Uea_document-section",
  "empty-features": "QV9Uea_empty-features",
  "empty-state": "QV9Uea_empty-state",
  "generate-button": "QV9Uea_generate-button",
  "history-list": "QV9Uea_history-list",
  "loading-document": "QV9Uea_loading-document",
  "loading-steps": "QV9Uea_loading-steps",
  "message": "QV9Uea_message",
  "notebook-document": "QV9Uea_notebook-document",
  "panel-description": "QV9Uea_panel-description",
  "read-only": "QV9Uea_read-only",
  "recipe-pane": "QV9Uea_recipe-pane",
  "steering-footer": "QV9Uea_steering-footer",
  "steering-panel": "QV9Uea_steering-panel",
  "toolbar-actions": "QV9Uea_toolbar-actions",
  "toolbar-left": "QV9Uea_toolbar-left",
  "with-recipe": "QV9Uea_with-recipe",
  "workspace-toolbar": "QV9Uea_workspace-toolbar",
});
